var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLeft(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 443.5 443.5",
    style: {
      enableBackground: "new 0 0 443.5 443.5"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M97.1,221.6c0-7.3,2.9-14.2,8.1-19.4L299.7,7.7c11-10.5,28.3-10.2,38.7,0.7c4.9,5.1,7.7,11.9,7.7,19s-2.7,14-7.7,19 L163.3,221.7l175,175c5.2,5.2,8.1,12.1,8.1,19.4s-2.9,14.3-8.1,19.3c-5.2,5.2-12.1,8-19.4,8c-7.3,0-14.2-2.9-19.2-8.1L105.2,240.9 C100,235.9,97.1,229,97.1,221.6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113,210.1L307.5,15.7c6.5-6.2,16.8-6.1,22.8,0.4c6.1,6.3,6.1,16.3,0,22.5l-182.9,183l182.9,182.9 c6.4,6.4,6.4,16.7,0,22.8c-6.4,6.4-16.7,6.4-22.8,0L113,233.1C106.8,226.8,106.8,216.5,113,210.1z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeft);
export default __webpack_public_path__ + "static/media/left.59cd9dadb09d89186ff529328a497b17.svg";
export { ForwardRef as ReactComponent };